import { render, staticRenderFns } from "./BaseTimezoneChooser.vue?vue&type=template&id=35bdcf3a&"
import script from "./BaseTimezoneChooser.vue?vue&type=script&lang=js&"
export * from "./BaseTimezoneChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports